import { useEffect, useState } from 'react';
import { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useFileSocket = (): Socket => {
  const [socket, setSocket] = useState<Socket>();
  const getSocket = useGetSocket(SocketNamespace.Files);

  useEffect(() => {
    const newSocket = getSocket();

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, [getSocket]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Files);

  return socket;
};